import DismissableMessage from 'components/DismissableMessage';
import { PvInputWrapper } from 'components/form/PvInputWrapper';
import { ReactSelectWrapper } from 'components/form/ReactSelectWrapper';
import { loginAction } from 'ducks/user';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { I18n, setLocale, Translate } from 'react-redux-i18n';
import { Divider, Fixed, Heading, Image, Modal, Text } from 'rebass';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components';
import { space } from 'styled-system';
import { dropdownStyle, PvButton } from 'styles/CustomComponents';
import logo from './leijona.svg';
import {getUnits} from "../../ducks/units";

const Lion = styled(Image)`
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const CustomModal = styled(Modal)`
  overflow: visible;
  max-width:600px;
`;

// styled-system does not support 'background' attribute
const GradientBg = styled(Fixed)`
  background: ${props => props.theme.colors.gradients.greenToGray}
`;

const Box = styled.div`
  ${space}
`;

const FloatRightText = styled(Text)`
  float: right
  cursor: pointer
`;

const unitsToDropdown = (units) => {
  return units.map(u => {
    return {value: u.code, label: `${u.name} (${u.code})`, code: u.code};
  }).sort((a, b) => {
    const nameA = a.label.toUpperCase(); // ignore upper and lowercase
    const nameB = b.label.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
};

class LoginModal extends React.Component {

  componentWillMount() {
    this.props.getUnits();
  }

  render() {

    const {
      changeLocale,
      error,
      handleSubmit,
      units,
      unitsLoading,
      pristine,
      submitting
    } = this.props;

    const submit = handleSubmit(loginAction);

    return (
      <form onSubmit={submit}>
        <GradientBg
          top={0}
          right={0}
          bottom={0}
          left={0}
        />
        <Fixed
          top={0}
          right={0}
          bottom={0}
          left={0}>
          <Lion height={'100%'} src={logo} />
        </Fixed>
        <CustomModal bg='rgba(255, 255, 255, .95)' width={['90%', '80%', '70%']}>
          <Heading is='h4' textAlign='center' mb={3}>PVKULTU</Heading>
          <Box px={[1, 2, 3, 4]}>
            <Box mb={3} className='clearfix'>
              <FloatRightText
                color='green'
                px={1}
                onClick={() => {
                  changeLocale('en');
                  moment.locale('en');
                }}>en
              </FloatRightText>
              <FloatRightText
                color='green'
                px={1}
                onClick={() => {
                  changeLocale('fi');
                  moment.locale('fi');
                }}>fi
              </FloatRightText>
            </Box>
            <Field
              component={ReactSelectWrapper}
              isLoading={unitsLoading}
              styles={dropdownStyle}
              placeholder={I18n.t('app.select_unit')}
              name='unit'
              options={unitsToDropdown(units)}
            />
            <Field
              autoComplete='username'
              component={PvInputWrapper}
              name='username'
              mt={3}
              autoFocus
              placeholder={I18n.t('app.username')} />
            <Field
              autoComplete='current-password'
              component={PvInputWrapper}
              name='password'
              mt={3}
              type='password'
              placeholder={I18n.t('app.password')} />
          </Box>
          {error && <DismissableMessage mt={3} bg='red'>{error}</DismissableMessage>}
          <Divider
            my={3}
            w={1}
            borderBottom={2}
            borderColor='grays.1'
          />
          <Text textAlign='center'>
            <PvButton disabled={pristine || submitting} type='submit'>
              <Translate value='app.login' />
            </PvButton>
          </Text>
        </CustomModal>
      </form>
    );
  }
}

LoginModal.propTypes = {
  changeLocale: PropTypes.func,
  error: PropTypes.string,
  handleSubmit: PropTypes.func,
  hideModal: PropTypes.func,
  units: PropTypes.array,
  unitsLoading: PropTypes.bool,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
};


const mapStateToProps = (state) => {
  return {
    i18n: state.i18n,
    units: state.units.unitsList,
    unitsLoading: state.units.loading
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  changeLocale: (locale) => setLocale(locale),
  getUnits: () => getUnits()
}, dispatch);

export default reduxForm({
  form: 'login'
})(connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginModal));


// WEBPACK FOOTER //
// ./src/components/modal/LoginModal.jsx